// Generated by CoffeeScript 2.7.0
import Admin__Settings__PushPackagesController from './settings_push_package.js';

import Admin__PushPackagesController from './push_package.js';

Skylark.App.Controllers.register({Admin__Settings__PushPackagesController, Admin__PushPackagesController});
